<template>
    <DataTable :url="api.ACTIONS.ROLES"
               :fieldsHiddenMain="['guard_name']"
               :fieldsHiddenEdit="['guard_name','permissions_count']"
               :fieldsDisabledEdit="['id','created_at','updated_at','permissions_count']"
               :fieldsHiddenAdd="['guard_name','id','created_at','updated_at','permissions_count']"
               :fieldsExtraAdd="fieldsExtraAdd"
               :fieldsExtraEdit="fieldsExtraEdit"
               :formatter="{permissions_count(value) {return JSON.stringify(value)}}"
               loadBeforeEdit
               :titles="titles"
               :title="$t('customers.roles.title')"

    />
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "Roles",
        title() {
            return this.$t("customers.roles.title");
        },
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": this.$t("common.name"),
                    "created_at": this.$t("customers.roles.createdAt"),
                    "updated_at": this.$t("customers.roles.updatedAt"),
                    "permissions_count": this.$t("customers.roles.permissionsCount"),
                    "permissions": this.$t("customers.roles.permissions")
                };
            },
            fieldsExtraAdd: () => ({
                permissions: "choose-permissions-multi"
            }),
            fieldsExtraEdit: () => ({
                permissions: "choose-permissions-multi"
            }),
        }
    }
</script>

<style scoped>

</style>